import { useFavorites } from '@/ui/Layout/Favorites/FavoritesContext';
import useHubTranslation from '@/utils/i18n/useHubTranslation';
import { StarBorderRounded, StarRounded } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import type { ReactElement } from 'react';

export default function FavoriteButton(): ReactElement {
  const { translateHubUi } = useHubTranslation();
  const { currentPage, isFavorite, isLoading, isMutating, toggleCurrentPage } =
    useFavorites();

  const isDisabled = !currentPage || isLoading || isMutating;
  const ariaLabel = isFavorite
    ? translateHubUi('nav.favorites.remove', 'Remove page from favorites')
    : translateHubUi('nav.favorites.add', 'Add page to favorites');

  return (
    <Tooltip title={ariaLabel}>
      <span>
        <IconButton
          disableRipple
          onClick={() => {
            toggleCurrentPage().catch(() => undefined);
          }}
          color='primary'
          aria-label={ariaLabel}
          disabled={isDisabled}
        >
          {isFavorite ? <StarRounded /> : <StarBorderRounded />}
        </IconButton>
      </span>
    </Tooltip>
  );
}
